import { HttpParams } from '@angular/common/http';
import { Filter } from '../../models';
import { toHTTPParam } from '../../core';
import { isPeriodicidadePeriodo, periodicidadeAnual } from './periodicidade';

/** Propriedades do filtro de periodicidade */
export interface PeriodicidadeFilterProps {
    periodicidade: number;
    data: Date;
    ano: number;
    semestre: number;
    trimestre: number;
    mes: number;
    dataInicio: Date;
    dataTermino: Date;
}

/** Filtro de periodicidade */
export class PeriodicidadeFilter implements PeriodicidadeFilterProps, Filter {
    periodicidade: number;
    data: Date;
    ano: number;
    semestre: number;
    trimestre: number;
    mes: number;
    dataInicio: Date;
    dataTermino: Date;

    constructor(props: Partial<PeriodicidadeFilterProps>) {
        if (props) {
            this.periodicidade = props.periodicidade ?? periodicidadeAnual.id;
            this.data = props.data ?? new Date();
            this.ano = props.ano;
            this.semestre = props.semestre;
            this.trimestre = props.trimestre;
            this.mes = props.mes;
            this.dataInicio = props.dataInicio;
            this.dataTermino = props.dataTermino
        } else {
            this.periodicidade = periodicidadeAnual.id;
            this.data = new Date();
        }
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        if (this.periodicidade) {
            params = params.append('periodicidade', this.periodicidade.toString());
        }

        if (isPeriodicidadePeriodo(this.periodicidade)) { // Período
            // Data Início
            if (this.dataInicio) {
                params = params.append('dataInicio', toHTTPParam(this.dataInicio));
            }
            // Data Término
            if (this.dataTermino) {
                params = params.append('dataTermino', toHTTPParam(this.dataTermino));
            }
        } else {
            // Data
            if (this.data) {
                params = params.append('data', toHTTPParam(this.data));
            }
        }

        return params;
    }

    clear() {
        this.periodicidade = null;
        this.data = null;
        this.ano = null;
        this.semestre = null;
        this.trimestre = null;
        this.mes = null;
        this.dataInicio = null;
        this.dataTermino = null;
    }

    /** Verificar se o filtro possui a periodicidade */
    hasValue(): boolean {
        // Periodicidade
        if (!this.periodicidade) {
            return false;
        }

        return true;
    }
}
